import React, { useEffect, useState } from "react";
import "./index.less";
import { ChatLayoutContainer } from "../ChatLayoutContainer";
import { AvatarComProps, ContactList } from "remo-components";
import { useTranslate } from "@obsbot/remo-i18n";
import { useFriendStore } from "@obsbot/remo-stores";
import { RouteNameType } from "../../route-config";
import { usePushHistory } from "../../utils/routes";
import { ListEmpty } from "remo-components";
const OnlineFriendsPage = (): React.ReactElement => {
    const t = useTranslate();
    const { friendList } = useFriendStore();
    const pushHistory = usePushHistory();
    const [online, setOnline] = useState<number>(friendList.length);

    const onClick = (path: string, info?: AvatarComProps): void => {
        console.log("toSendMessage", path, info);
        if (info) {
            pushHistory(path as RouteNameType, {
                id: info.userID,
                name: info.userName?.toString().trim() || info.userID,
            });
        }
    };

    useEffect(() => {
        const tempCount = friendList.filter(
            item =>
                item.profile.profileCustomField.filter(
                    e => e.key === "Tag_Profile_Custom_Status",
                )[0]?.value === "online",
        ).length;
        setOnline(tempCount);
    }, [friendList]);
    return (
        <ChatLayoutContainer>
            {online > 0 ? (
                <div className="online-friends-page">
                    <div className="friend-page-title">
                        {t("chat.online", {
                            user: "  " + online + " " + t("chat.people"),
                        })}
                    </div>
                    <ContactList modeType="list-online" onClick={onClick} />
                </div>
            ) : (
                <div className="online-friends-page-empty">
                    <ListEmpty modeType="list-online" />
                </div>
            )}
        </ChatLayoutContainer>
    );
};

export default OnlineFriendsPage;
